import * as React from "react"
import { Form } from 'react-bootstrap';
import Select from 'react-select'

export const CustomInput = ({ label, type, placeholder, name, hasRequired, value, readOnly, multiple }) => {
    return (
        <>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>{label}{hasRequired && (<sup className="text-danger">*</sup>)}</Form.Label>
                <Form.Control type={type ?? "text"} name={name} placeholder={placeholder ?? ""} value={value} readOnly={readOnly} multiple={multiple ?? false} required={hasRequired ?? false}/>
            </Form.Group>
        </>
    );
};

export const CustomSelect = ({ label, placeholder, name, children, hasRequired, value }) => {
    return (
        <>
            <Form.Group className="mb-3" controlId="">
                <Form.Label>{label}{hasRequired && (<sup className="text-danger">*</sup>)}</Form.Label>
                <Form.Select aria-label="select" name={name} placeholder={placeholder ?? ""} defaultValue={value ?? ''} required={hasRequired ?? false}>
                    {children}
                </Form.Select>
            </Form.Group>
        </>
    );
};


export const CustomSelect2 = ({ label, placeholder, name, children, hasRequired }) => {
    return (
        <>
            <Form.Group className="mb-3" controlId="">
                <Form.Label>{label}{hasRequired && (<sup className="text-danger">*</sup>)}</Form.Label>
                <Form.Select aria-label="select" name={name} placeholder={placeholder ?? ""} required={hasRequired ?? false}>
                    {children}
                </Form.Select>
            </Form.Group>
        </>
    );
};

export const CustomTextarea = ({ label, placeholder, name, hasRequired}) => {
    return (
        <>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>{label}{hasRequired && (<sup className="text-danger">*</sup>)}</Form.Label>
                <Form.Control as="textarea" rows={3} name={name} placeholder={placeholder ?? ""} required={hasRequired ?? false} />
            </Form.Group>
        </>
    );
};

export const CustomMultiSelect = ({ label,  name, hasRequired , options, isMulti }) => {

    const customStyles = {
        option: (provided, state) => ({
          ...provided,
          fontSize: "14px",
          fontWeight: state.isSelected ? '700' : '700',
          color: '#000'
          
        }),
        
        singleValue: (provided, state) => ({
            ...provided,
            fontSize: "14px",
            fontWeight: state.isSelected ? '700' : '700',
            
          })
      }

   
    return (
        <>
            <Form.Group className="mb-3" controlId="">
                <Form.Label>{label}{hasRequired && (<sup className="text-danger">*</sup>)}</Form.Label>
                <Select options={options} isMulti={isMulti} placeholder="" name={name} styles={customStyles} required={hasRequired ?? false}/>
            </Form.Group>
        </>
    );
};







